import gql from 'graphql-tag'
import {
  ApolloClientCollectionItem,
  ShopConfigQueryResult,
} from './shopConfigLoader.types'

export interface GetConfigOfShopConfigResponse {
  data: {
    config: ShopConfigQueryResult
  }
  loading: boolean
  networkStatus: number
  stale: boolean
}

export type ApolloClientCollection = ApolloClientCollectionItem[]

export const GET_CONFIG = gql`
  query {
    config: getConfig {
      campaignAbTests {
        id
        abTestId
      }
      menuAbTests(menuType: "web") {
        key
        value
      }
      shopConfig
      featureFlags
    }
  }
`
